import { useKrakenQuery } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import { DIRECT_DEBIT_INSTRUCTION_STATUS } from '@/consts/directDebit';
import { useAccountNumberContext } from '@/context/AccountNumberContext/withFetch/AccountNumberContext';

import { hasCurrentDirectDebitInstructionSchema } from '../validations';

import HasCurrentDirectDebitInstruction from './HasCurrentDirectDebitInstruction.graphql';

export type CurrentDirectDebitInstructionNodeType = {
  node: {
    id: string;
    status: DIRECT_DEBIT_INSTRUCTION_STATUS;
  };
};

export const useHasCurrentDirectDebitInstruction = () => {
  const { isAuthenticated } = useAuth();

  const { accountNumber } = useAccountNumberContext();

  return useKrakenQuery<
    unknown,
    unknown,
    CurrentDirectDebitInstructionNodeType
  >({
    queryKey: ['hasCurrentDirectDebitInstruction'],
    query: HasCurrentDirectDebitInstruction,
    select: (data: any) => data.account.directDebitInstructions.edges[0],
    variables: { accountNumber },
    validateFn(response) {
      return hasCurrentDirectDebitInstructionSchema.validate(response);
    },
    enabled: Boolean(isAuthenticated && accountNumber),
    gcTime: 0,
  });
};
